import * as Yup from 'yup';
import { v4 as uuidv4 } from 'uuid';

import { capitalize } from 'utils/string';
import { PaymentMethodType } from 'types';

import { FormValues } from './types';

export const getInitialValues = ({
  data,
  amount,
  tipAmount,
  freeShippingAmount,
  processingFeeAmount,
}: {
  amount?: number;
  data?: FormValues;
  tipAmount?: number;
  freeShippingAmount?: number;
  processingFeeAmount?: number;
}): FormValues =>
  data ?? {
    type: '',
    id: uuidv4(),
    tip: tipAmount,
    amount: amount || 0,
    cloverPaymentId: '',
    processingFee: processingFeeAmount,
    freeShipping: freeShippingAmount || 0,
  };

export const getValidationSchema = ({
  maxAmount,
  maxTipAmount,
  maxFreeShippingAmount,
  maxProcessingFeeAmount,
  isManualCreditPaymentEnabled,
}: {
  maxAmount: number;
  maxTipAmount: number;
  maxFreeShippingAmount: number;
  maxProcessingFeeAmount: number;
  isManualCreditPaymentEnabled?: boolean;
}) =>
  Yup.object().shape({
    type: Yup.string().required(),
    tip: Yup.number().max(maxTipAmount),
    amount: Yup.number().required().max(maxAmount),
    freeShipping: Yup.number().max(maxFreeShippingAmount),
    processingFee: Yup.number().max(maxProcessingFeeAmount),
    cloverPaymentId: Yup.string().when('type', {
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
      is: (type: string) => type === 'credit' && !isManualCreditPaymentEnabled,
    }),
  });

export const getPaymentTypeOptions = (types: PaymentMethodType[]) =>
  types.map((value) => ({ value, label: capitalize(value) }));
